import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Application } from '../../models/interfaces';
import Message from '../../components/ui/Message';
import { ApplicationsContext } from '../../context/applications/ApplicationContext';

export const ApprovalsPage = () => {

    const navigate = useNavigate();

    const { applications, loadApplications, isLoading, approveRequest, rejectRequest, deleteRequest } = useContext(ApplicationsContext);

    const [buscar, setBuscar] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const [approveMessage, setApproveMessage] = useState('');
    const [rejectMessage, setRejectMessage] = useState('');
    const [currentApp, setCurrentApp] = useState(0);
    const [action, setAction] = useState('reject');



    useEffect(() => {
        loadApplications(['PENDING']); // ACT | INA | ALL
    }, []);

    const filteredData = applications.filter((app: Application) =>
        app.BUSINESS_NAME.toLowerCase().includes(buscar.toLowerCase()) ||
        app.MERCHANT_RUC.toLowerCase().includes(buscar.toLowerCase())
    );



    const handleView = (application: Application) => {
        navigate('/approval', { state: { application } });
    };



    const handleApprove = async (appId: number) => {
        setCurrentApp(appId);
        setApproveMessage("¿Confirma que desea aprobar este cliente?")

    };
    const handleReject = async (appId: number) => {
        setCurrentApp(appId);
        setRejectMessage("¿Confirma que desea devolver este cliente?")
    };
    const handleDecline = async (appId: number) => {
        setCurrentApp(appId);
        setAction("decline")
        setRejectMessage("¿Confirma que desea eliminar esta solicitud?")
    };

    const removeError = () => {
        setErrorMessage('');
    };

    const removeSuccessMessage = () => {
        setSuccessMessage('');

    };

    const removeRejectMessage = () => {
        setRejectMessage('');
    };


    const removeApproveMessage = () => {
        setApproveMessage('');
    };

    const confirmApprove = async () => {

        setApproveMessage('');
        const resp = await approveRequest(currentApp.toString());
        if (resp == 'success') {
            setSuccessMessage("La aprobación se realizó correctamente.");
            loadApplications(['PENDING']);
        } else {
            setErrorMessage(resp);
        }
    };

    const rejDecRequest = async (reason: string) => {

        removeRejectMessage()
        let resp;
        if (action == 'reject') {
            resp = await rejectRequest(currentApp.toString(), reason);
        } else {
            resp = await deleteRequest(currentApp.toString(), reason);
        }

        if (resp == 'success') {
            setSuccessMessage(action == 'reject' ? "La solicitud se rechazó correctamente." : "La solicitud se eliminó correctamente.");
            loadApplications(['PENDING']);
        } else {
            setErrorMessage(resp);
        }
    };

    return (
        <div className='mt-5 container' style={styles.container}>

            {/* BUSCADOR + NUEVO */}
            <div className="row justify-content-end mt-5">
                <div className="col-md-3">
                    <input
                        className="form-control"
                        type="text"
                        placeholder="Buscar"
                        value={buscar}
                        onChange={(e) => setBuscar(e.target.value)}
                    />
                </div>


            </div>

            <br />

            {/* TABLA */}
            <table className="table table-hover table-striped">
                <thead className="thead-dark">
                    <tr>
                        <th># Solicitud</th>
                        <th>Banco</th>
                        <th>Número Id Fiscal</th>
                        <th>Nombre Comercial</th>
                        {/* <th>Contacto</th>
                        <th>Email</th> */}
                        <th>Estado</th>
                        <th>Creado</th>
                        <th style={{ textAlign: 'center' }}>Acciones</th>
                    </tr>
                </thead>

                <tbody>
                    {
                        filteredData.length > 0
                            ? filteredData.map((app: Application) => (
                                <tr key={app.APP_ID}>
                                    <td>{app.APP_ID}</td>
                                    <td>{app.BANK_CODE}</td>
                                    <td>{app.MERCHANT_RUC}</td>
                                    <td>{app.BUSINESS_NAME}</td>
                                    {/* <td>{app.CONTACT_PERSON}</td>
                                    <td>{app.CONTACT_EMAIL ?? '-'}</td> */}
                                    <td>{<td>{app.STATUS == 'PENDING' ? 'Pendiente' : app.STATUS}</td>}</td>
                                    <td>{new Date(app.CREATED_AT).toLocaleDateString()}</td>
                                    <td style={{ textAlign: 'center' }}>
                                        <div className="dropdown">
                                            <button
                                                className="btn btn-secondary dropdown-toggle"
                                                type="button"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                            >
                                                <span className='bi bi-list'></span>
                                            </button>

                                            <ul className="dropdown-menu">
                                                <li>
                                                    <button
                                                        className="dropdown-item text-info"
                                                        onClick={() => handleView(app)}
                                                    >
                                                        <i className="bi bi-eye me-2"></i>
                                                        Ver
                                                    </button>
                                                </li>
                                                <li>
                                                    <hr className="dropdown-divider" />
                                                </li>
                                                <li>
                                                    <button
                                                        className="dropdown-item text-success"
                                                        onClick={() => handleApprove(app.APP_ID)}
                                                    >
                                                        <i className="bi bi-check-circle me-2"></i>
                                                        Aprobar
                                                    </button>
                                                </li>
                                                <li>
                                                    <hr className="dropdown-divider" />
                                                </li>
                                                <li>
                                                    <button
                                                        className="dropdown-item text-secondary"
                                                        onClick={() => handleReject(app.APP_ID)}
                                                    >
                                                        <i className="bi bi-x-circle me-2"></i>
                                                        Rechazar
                                                    </button>
                                                </li>
                                                <li>
                                                    <hr className="dropdown-divider" />
                                                </li>

                                                <li>
                                                    <button
                                                        className="dropdown-item text-danger"
                                                        onClick={() => handleDecline(app.APP_ID)}
                                                    >
                                                        <i className="bi bi-trash me-2"></i>
                                                        Eliminar
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    {/* <td style={{ textAlign: 'center' }}>
                                        <button
                                            className="btn btn-sm btn-primary"
                                            onClick={() => handleEdit(app)}
                                        >
                                            Editar
                                        </button>
                                    </td> */}
                                </tr>
                            ))
                            : (
                                <tr>
                                    <td colSpan={9} className="text-center">
                                        {isLoading ? 'Cargando...' : 'No existen aplicaciones.'}
                                    </td>
                                </tr>
                            )
                    }
                </tbody>
            </table>

            {/* MENSAJE DE ERROR */}
            {
                errorMessage.length > 0 &&
                <Message
                    type="error"
                    message={errorMessage}
                    closeDialog={removeError}
                    handleOk={removeError}
                />
            }

            {approveMessage &&
                <Message
                    type="success"
                    title="Confirmar"
                    message={approveMessage}
                    closeDialog={removeApproveMessage}
                    showCancel={true}
                    handleCancel={removeApproveMessage}
                    handleOk={confirmApprove}
                    okText="Confirmar"
                    backgroundColor="rgba(0,0,0,0.4)"
                />
            }

            {successMessage &&
                <Message
                    type="success"
                    title="Exitoso"
                    message={successMessage}
                    closeDialog={removeSuccessMessage}
                    handleOk={removeSuccessMessage}
                    backgroundColor="rgba(0,0,0,0.4)"
                />
            }

            {rejectMessage &&
                <Message

                    type="success"
                    title="Confirme"
                    message={rejectMessage}
                    closeDialog={removeRejectMessage}
                    handleOk={rejDecRequest}
                    showReasonField={true}
                    backgroundColor="rgba(0,0,0,0.4)"
                />
            }

        </div>
    );
};

const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
